import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SendInvitationDialog, SendInvitationPost } from '@core/models/leave-admin/employees/send-invitation-post.model';
import { LayoutService, NotificationService, SnackbarService } from '@core/services';
import { ManageEmployeesService } from '@core/services/manage-employees.service';
import { position, onDragEnded } from '@shared/helpers/dialog-drag-constraints';
import { indicate, keepDialogOpen } from '@shared/helpers';
import { Observable, Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { EmailResult } from '@core/enums';

@Component({
    selector: 'app-send-invitation',
    templateUrl: './send-invitation.component.html',
    styleUrls: ['./send-invitation.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SendInvitationComponent implements OnInit {
  static readonly componentName = 'SendInvitationComponent';
  
  public position = position;
  public onDragEnded = onDragEnded;

  isSubmitting$: Subject<boolean>;

  public isMobile$: Observable<boolean>;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { 
      inviteDialog: SendInvitationDialog; 
      sysText: any;
    },
    private sendInvitationdialogRef: MatDialogRef<SendInvitationComponent>,
    private manageEmployeesService: ManageEmployeesService,
    private layoutService: LayoutService,
    private snackbar: SnackbarService,
    private notificationService: NotificationService
    ) { 
    this.isSubmitting$ = new Subject();
  }

  ngOnInit(): void {
    this.isMobile$ = this.layoutService.isMobile$();
  }

  save(): void {
    const dto: SendInvitationPost = {
      employeeId: this.data.inviteDialog.employeeId
    }

    this.manageEmployeesService.postSendInvitation(dto)
      .pipe(
        indicate(this.isSubmitting$),
        keepDialogOpen(this.sendInvitationdialogRef),
        finalize(() => {
          this.sendInvitationdialogRef.close();
        })
      )
      .subscribe(
        (res) => {
          this.sendInvitationdialogRef.close();

          if (res == EmailResult.success) {
            let snackText = this.data.sysText.invitationSuccess;
            this.snackbar.open(snackText, this.data.sysText.dismiss);
          }
          else if (res == EmailResult.successWithFailure) {
            let errorText = this.data.sysText.invitationSuccessWithFailure;
            this.notificationService.showErrorToast(errorText);
          }
          else {
            let errorText = this.data.sysText.invitationFailure;
            this.notificationService.showErrorToast(errorText);
          }
      });
  }
}
